// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__38lPV","monthColumnWrapper":"Header_monthColumnWrapper__2xmID","filler":"Header_filler__1wKAQ"};